<!-- <link rel="stylesheet" href="../../custom.css"> -->
<template>
  <div class="box">
    <div @click="clickOption" class="option" v-for="option in options" v-bind:key="option.id" :data-id="option.id">
      <span>{{ option.option }}</span>
    </div>
  </div>
</template>

<script>
import common from "../../common";
import $ from 'jquery';

export default {
  name: "TestOption",
  props: {
    options: { type: Array },
    voice_play: { type: Boolean },
    record_initial_time: { type: Number, default: 0 },
  },
  data() {
    return {
      i: 0,
      time: [9, 5, 5, 4.2, 5],
      timeout_init: null,
      timeout: null,
      inter: null,
      seq: 1,
      selectedOption: null,
    }
  },
  mounted() {
    this.isLiterate();
  },
  updated() {
    if (this.voice_play) {
      this.resetOption();
      if (this.i == 5) {
        clearInterval(this.inter);
        clearTimeout(this.timeout_init);
        clearTimeout(this.timeout);
        $('.option').eq(this.i - 1).find('span').removeClass('hide-ele');
        this.i = 0;
        this.isLiterate();
      }
    }
  },
  unmounted() {
    clearInterval(this.inter)
    clearTimeout(this.timeout_init)
    clearTimeout(this.timeout)
  },
  methods: {
    isLiterate: function () {
      common.getUserInfo().then(user_info => {
        common.getStorage('is_literate_' + user_info.id).then(is_literate => {
          if (!is_literate) {
            this.flicker();
          }
        })
      })
    },
    clickOption: function (e) {
      if (!this.voice_play) {
        const objs = document.getElementsByClassName('option');
        for (let i = 0; i < objs.length; i++) {
          objs[i].classList.remove('selected');
        }

        let id = 0;
        if ($(e.target).hasClass('option')) {
          e.target.classList.add('selected')
          id = e.target.dataset.id;
        } else {
          $(e.target).parent().addClass('selected')
          id = $(e.target).parent().data('id')
        }

        this.selectedOption = e.currentTarget;
        this.getAnswer(id)
        this.$emit('selectStoryOption')
        this.$emit('addActionSequence', {
          seq: this.seq++,
          x: e.x * window.devicePixelRatio,
          y: e.y * window.devicePixelRatio,
          input_time: common.getTestRecordTime(this.record_initial_time),
          input: id,
        })
      }
    },
    getAnswer: function (value) {
      this.$emit('getAnswer', value);
    },
    flicker: function () {
      const time = this.time[this.i]
      const i = this.i;

      if (!time) {
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;

      this.timeout_init = setTimeout(function () {
        that.inter = setInterval(function () {
          $('.option').eq(i).find('span').toggleClass('hide-ele')
        }, 400)
      }, i === 0 ? 4700 : 0)

      this.timeout = setTimeout(function () {
        clearInterval(that.inter)
        $('.option').eq(i).find('span').removeClass('hide-ele')
        that.flicker();

      }, time * 1000)

      this.i++;

    },
    resetOption: function () {
      if (this.selectedOption !== null) {
        this.selectedOption.classList.remove('selected');
      }
    }
  }
}
</script>

<style scoped>
.box {
  margin-top: clamp(0.75rem, 2vw, 1.5rem);
}

.option {
  text-align: center;
  font-size: var(--ecs-font-md);
  min-height: clamp(2.75rem, 5vw, 4rem);
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
  border-radius: var(--ecs-radius-md);
  margin: clamp(0.5rem, 1vw, 0.75rem) auto;
  padding: 0.375rem 1rem;
  line-height: 1.3;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: normal;
  cursor: default;
}

@media (orientation: landscape) and (max-height: 480px) {
  .box {
    margin-top: clamp(0.5rem, 1.4vw, 0.875rem);
  }

  .option {
    min-height: clamp(2.25rem, 4vw, 3rem);
    margin: clamp(0.25rem, 0.75vw, 0.5rem) auto;
    padding: 0.25rem 1rem;
  }
}

.selected {
  background: #94c43b;
  color: white;
}

.hide-ele {
  visibility: hidden;
}
</style>
